import React from 'react';
import { IconProps } from './types';

const BoldLockOpen: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    width={size * 0.8}
    height={size}
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14C7.448 14 7 13.552 7 13C7 12.448 7.448 12 8 12C8.552 12 9 12.448 9 13C9 13.552 8.552 14 8 14ZM8 10C6.346 10 5 11.346 5 13C5 14.654 6.346 16 8 16C9.654 16 11 14.654 11 13C11 11.346 9.654 10 8 10ZM14 17C14 17.552 13.552 18 13 18H3C2.448 18 2 17.552 2 17V9C2 8.448 2.448 8 3 8H13C13.552 8 14 8.448 14 9V17ZM13 6H6V4C6 2.897 6.897 2 8 2C9.103 2 10 2.897 10 4C10 4.553 10.447 5 11 5C11.553 5 12 4.553 12 4C12 1.794 10.206 0 8 0C5.794 0 4 1.794 4 4V6H3C1.346 6 0 7.346 0 9V17C0 18.654 1.346 20 3 20H13C14.654 20 16 18.654 16 17V9C16 7.346 14.654 6 13 6Z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default BoldLockOpen;
